export default ({
    name : 'HamburgerMenu'
    , props : {
        'profileIconColorClass' : String // common_header computed value.
    }
    , data () {
        return {}
    },
    created () {
        this.code = 'hamburger_menu';
        this.basic = this.getDetailDataByCode(this.code);
        return {}
    },
    computed : {
        //isUseHambugerMenu : function () {
            //if (this.basic.use == 'N') { return false; }
            //return true;
        //}
        isUseHomeBtn : function () {
            if (this.isUse() === true || this.viewHome === false) { return false; }
            return true;
        }
        , searchClass () {
            let _class = {
                'left-move' : false
            }
            if (this.isUse() === true || this.viewHome === true) { 
                _class["left-move"] = true;
            }
            return _class;
        }
        , linkSohoSearchUrl () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlSohoSearch
        }
        , targetSohoSearch () {
            return this.getAdminEditMode() ? '' : '_blank'
        }
    }
})
